
<template>
    <div>
       <div style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("stepper.title7")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section>
                <div class="row">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.countrycode")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.ContactInformation.MobileNoCode}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.mobileno")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.ContactInformation.MobileNo}}
                    </div>
                    
                    
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Applicant-Detail.email")}}
                        </div>
                        <div class="col-xs-12 col-md-3 q-mb-md">
                            {{StoreStateAOD.ContactInformation.EmailAddress}}
                        </div>
                </div>
            </q-card-section>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryContactlInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>